import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger, Toastr } from 'data/common';
import Translator from 'translator';
import api from './api';

const apiCaller = getApiInstance();

export function getUsersManagers(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllUsersManagers(env))
            .then(({ data }) => {
                if (data.success) {
                    console.log(data, 'lelelele')
                    dispatch({
                        type: `${env.toUpperCase()}__SET_USERSMANAGERS`,
                        usersManagers: data.usersManagers
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setUsersManagers - ', error);
                throw error;
            });
    };
}

export function getUserManagerDetails(env, userManagerId) {
    return dispatch => {
        return apiCaller
            .call(api.getUserManagerDetails(env, userManagerId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_USERMANAGER`,
                        userManagerId,
                        userManager: data.userManager
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getUserManagerDetails - ', error);
                throw error;
            });
    };
}

export function resetPassword(env, userManagerId) {
    return () => {
        return apiCaller
            .call(api.resetPassword(env, userManagerId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setResetPassword - ', error);
                throw error;
            });
    };
}

export function generateCode(env, userManagerId) {
    return () => {
        return apiCaller
            .call(api.generateCode(env, userManagerId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setGenerateCode - ', error);
                throw error;
            });
    };
}

export function updateUserManagerDetails(env, userManagerId, form) {
    return dispatch => {
        return apiCaller
            .call(api.updateUserManagerDetails(env, userManagerId, form))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_USERMANAGER`,
                        userManagerId,
                        userManager: data.userManager
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateUserManagerDetails - ', error);
                throw error;
            });
    };
}

export function addUserManager(env, userManagerForm) {
    return dispatch => {
        return apiCaller
            .call(api.addUserManager(env, userManagerForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_USERMANAGER`,
                        userManager: data.userManager,
                        userManagerId: data.userManagerId
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: addUserManager - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.env, ${
                                    data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message
                                }`,
                                'api.message.env, default'
                            ),
                            Translator.translate('api.message.env, intermediate_error')
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addUserManager - ', error);
                throw error;
            });
    };
}

export function deleteUserManager(env, userManagerId) {
    return dispatch => {
        return apiCaller
            .call(api.deleteUserManager(env, userManagerId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__DELETE_USERSMANAGER`,
                        userManagerId
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteUsersManager - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/UsersManagers/actions.js